const Languages = [
    { value: 'english', label: 'English' },
    { value: 'french', label: 'French' },
];
export default Languages
